import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth.slice";
import { userRegisterReducer } from "./userRegister.slice";
import { memberReducer } from "./members.slice";
import { dropdownReducer } from "./dropdownOptions.slice";
import { committeeReducer } from "./committee.slice";
import { masterReducer } from "./master.slice";
import { homePageReducer } from "./home.slice";
import { menuReducer } from "./menu.slice";
import { eventsReducer } from "./events.slice";
import { documentsReducer } from "./documents.slice";
import { additionalResourceReducer } from "./additionalResoure.slice";
import { categoryReducer } from "./category.slice";
import { profileReducer } from "./myProfile.slice";
import { postformReducer } from "./post.slice";
import { superAdminDashboardReducer } from "./superAdminDashboard.slice";
import { committeeAdminDashboardReducer } from "./committeeAdminDashboard.slice";
import { editorReducer } from "./editor.slice";
import { reportReducer } from "./reports.slice";

export * from "./auth.slice";
export * from "./userRegister.slice";

export const store = configureStore({
  reducer: {
    master: masterReducer,
    members: memberReducer,
    committee: committeeReducer,
    dropDown: dropdownReducer,
    menu: menuReducer,
    events: eventsReducer,
    home: homePageReducer,
    auth: authReducer,
    register: userRegisterReducer,
    documents: documentsReducer,
    additionalResource: additionalResourceReducer,
    category: categoryReducer,
    profile: profileReducer,
    post: postformReducer,
    superAdminDashboard: superAdminDashboardReducer,
    committeeAdminDashboard: committeeAdminDashboardReducer,
    editor: editorReducer,
    report: reportReducer,
  },

  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware().concat(maintenanceMiddleware),

  devTools: process.env.REACT_APP_ENV !== "production", // Enables DevTools only in development mode
});
